import CodeMirror from "codemirror";
import _ from "underscore";
import "utils/codemirror-overlaymode";

CodeMirror.defineMode("inline-editor", function (config) {
  var overlay = {
    token: function (stream) {
      var ch;
      if (stream.match("{{")) {
        // Consume the "{{stuff}}" token.
        while ((ch = stream.next()) != null) {
          if (ch === "}" && stream.next() === "}") {
            const oldPlaceHolder = stream.current();
            const configString = config.value.split(oldPlaceHolder)[0];
            const streamString = stream?.string?.split(oldPlaceHolder)[0] || "";
            // Note: There is a bug on CodeMirror.js that does not allow us to use object here. Hence we use stringify.
            // Documentation tells a token can be anything, but JSON object usage breaks the initialization of CodeMirror.
            const stringToken = JSON.stringify({
              placeHolder: "inline-editor",
              preString: configString || streamString,
            });
            stream.eat("}");
            return stringToken;
          }
        }
      } else {
        // Consume everything up to, but not including, next "{{".
        while (!stream.eol() && !stream.match("{{", false)) {
          stream.next();
        }
      }
      return null;
    },
  };
  _.extend(config, config.baseMode);
  return CodeMirror.createOverlayMode(
    CodeMirror.getMode(config, config.mode),
    overlay,
  );
});
